export default __webpack_public_path__ + "static/media/Deloitte.2403ff76.png";